export default "__VITE_ASSET__BkxCd2YG__"